import React, { useEffect } from "react";
import { connect } from "react-redux";
import Home from "./screens/Public/Home";
import { navigateTo } from '../../actions/navigator';
import LoaderComponent from "./screens/Public/Loader";

const Default = props => {
	let access_token = localStorage.getItem('access_token');
	let access_expiry = localStorage.getItem('access_expiry');
	useEffect(() => {
		navigateWhereNeeded();
	})
	const navigateWhereNeeded = () => {
		const { currentUser, dispatch, isMobile } = props;
		if (currentUser) {
			if (currentUser.profile) {
				if (!isMobile) {
					if (currentUser.profile.profile_type === "STUDENT") {
						if (currentUser.portfolio_job_roles && currentUser.portfolio_job_roles.length === 0)
							dispatch(navigateTo({ path: ['jobRoles'] }))
						else
							dispatch(navigateTo({ path: ['dashboard'] }));
					}
					else if (currentUser.profile.profile_type === "ADVISOR")
						dispatch(navigateTo({ path: ['mentorDashboard'] }));
					else if (currentUser.profile.profile_type === "INSTITUTION")
						dispatch(navigateTo({ path: ['instituteDashboard'] }));
					else if (currentUser.profile.profile_type === "COMPANY")
						dispatch(navigateTo({ path: ['companyDashboard'] }));
				}
				else
					dispatch(navigateTo({ path: ['posts'] }));
			}
			else if (currentUser.profile_type) {
				dispatch(navigateTo({ path: ['createProfile'] }));
			}
		}
	}

	return (
		<div>
			{props.currentUser ?
				null :
				access_token && access_expiry ? 
					<LoaderComponent />
				:
				<Home {...props} />
			}
		</div>
	)
}

const mapStateToProps = state => {
	const { environment, currentUser } = state;
	const { isMobile } = environment;

	return {
		currentUser,
		isMobile
	};
}

export default connect(mapStateToProps)(Default);